export default "__VITE_ASSET__BjsB_$u7__";